module.exports = __webpack_public_path__ + "static/media/ic-educacao-fisica-min.c5640be1.svg";